import { Application } from '../framework/application';
import { Constructor } from './types/constructor.type';
import { domReady } from './dom-ready.fn';

export async function bootstrap<T extends Application>(
  application: Constructor<T>
) {
  await domReady(async () => {
    const app = new application();
    await app.start();
  });
}
